import { toNumber } from 'lodash-es';
import { ReturnItem } from 'services/api/refund';

export const getOrderTotalAmount = (order: Conversation.Trade.Vo) => {
  const { totalAmount, buyerPayment } = order;

  if (totalAmount) {
    return toNumber(totalAmount);
  }

  if (buyerPayment && buyerPayment.buyerTotalAmount) {
    return toNumber(buyerPayment.buyerTotalAmount);
  }

  return 0;
};

export const getOrderProductPropsFromTradeProduct = (product: Conversation.Trade.Product) => {
  const {
    itemId,
    itemName,
    itemPic,
    itemUrl,
    unitPrice,
    sku,
    sellerSku,
    quantity,
    promotionType,
    discountedPrice,
    isPreOrder,
    digitalInfo,
    warehouse,
    goodsPrepareTime,
    itemComments,
    combinedListingSkus,
  } = product;

  return {
    itemId,
    itemName,
    itemPic,
    itemUrl,
    unitPrice,
    sku,
    sellerSku,
    quantity,
    promotionType,
    discountedPrice,
    isPreOrder,
    digitalInfo,
    warehouse,
    goodsPrepareTime,
    itemComments,
    combinedListingSkus,
  };
};

export const getOrderProductPropsFromReturnItem = (item: ReturnItem) => {
  const { itemImage, returnQuantity, itemPrice, itemName, itemId, skuId, sellerSku } = item;

  return {
    itemId,
    itemName,
    itemPic: itemImage?.[0],
    itemUrl: '',
    sku: skuId,
    sellerSku,
    quantity: returnQuantity,
    discountedPrice: itemPrice,
    isPreOrder: false,
  };
};

export const isOrderCompleted = (tradeStatus: Conversation.Trade.Vo['tradeStatus']) => {
  return tradeStatus === 'TRADE_SUCCESS';
};
